import React from 'react';
import { Button, Tooltip } from 'antd';
import { DoubleRightOutlined, DoubleLeftOutlined, InfoCircleOutlined } from '@ant-design/icons';
import TemplateGenerator from '../template-generator';
import CopyButton from '../copy-button';

var Operations = (_ref) => {
  var {
    config,
    resource,
    activeKey,
    listSeperator,
    setListSeperator,
    setInfoDrawerVisible
  } = _ref;
  var copyProps = {
    key: 'operations-copy-button',
    textToCopy: resource,
    buttonStyle: {
      type: 'link'
    }
  };
  var content = [/*#__PURE__*/React.createElement(Tooltip, {
    key: "show-info",
    title: "Show Info"
  }, /*#__PURE__*/React.createElement(Button, {
    type: "link",
    icon: /*#__PURE__*/React.createElement(InfoCircleOutlined, {
      onClick: event => {
        // If you don't want click extra trigger collapse, you can prevent this:
        event.stopPropagation();
        setInfoDrawerVisible(true);
      }
    })
  })), /*#__PURE__*/React.createElement(CopyButton, copyProps)];

  if (activeKey === 'excel' || activeKey === 'sheets') {
    var toggleListSeperatorIcon = listSeperator ? /*#__PURE__*/React.createElement(DoubleLeftOutlined, null) : /*#__PURE__*/React.createElement(DoubleRightOutlined, null);
    var templateGeneratorProps = {
      key: 'operations-template-generator',
      type: activeKey,
      config
    };
    content.push( /*#__PURE__*/React.createElement(Tooltip, {
      key: "toggle-list-seperator",
      title: "Toggle List Seperator"
    }, /*#__PURE__*/React.createElement(Button, {
      onClick: () => setListSeperator(!listSeperator),
      type: "link",
      icon: toggleListSeperatorIcon
    })));
    content.push( /*#__PURE__*/React.createElement(TemplateGenerator, templateGeneratorProps));
  }

  return content;
};

export default Operations;